import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";



export const studentSessionDetailsSuccess = (data) => {
  return {
    type: actionTypes.STUDENTS_SESSION_DETAILS,
    payload: {
      sessionDetails: data.Data,
    },
  };
};

export const studentSessionDetails = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetStudentSessionDetails`, data)
    .then((response) => {
      if (response) {
        dispatch(studentSessionDetailsSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};